import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      backgroundColor: theme.palette.grey[100],
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0, 2),
      minHeight: theme.spacing(5.375),
      width: '100%',
    },
    title: {
      ...theme.typography.h6,
      color: theme.palette.greyBlue[700],
    },
  };
});

export default function PrintMenuHeader({ headerText }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h3 className={classes.title} id="page-range-select-group">
        {headerText}
      </h3>
    </div>
  );
}
